import React from "react";

export default function ChatHeader({
  children,
}: {
  children?: React.ReactNode;
}) {
  return <div className="shrink w-full pt-5 pb-10 px-10 ">{children}</div>;
}
